import React, {Fragment} from 'react'
import Buttons from './element/buttons';

export default function PartMosaic(props) {
    let part = props.part;
    // let items = part['multiple'];
    let multiple_type = part['multiple_type'];
    // let item_className = 'oneoftwo';

    let multiple_elm = React.createElement(multiple_type);
    return (
        <Fragment>
            {
                part['content'] !== '' &&
                    <div className="text">
                        <div dangerouslySetInnerHTML={{__html: part['content']}} />
                    </div>
            }
            {
                props.part_buttons &&
                    <Buttons part_buttons={props.part_buttons} />
            }
            <div className={`multiple multiple--${multiple_type} flex`}>
                {multiple_elm}
            </div>
        </Fragment>
    )
}


